<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="eventpromotion_breadcrumb" />
    </div>

    <div class="header">
      <h1 class="overlay">EVENT&PROMOTION</h1>
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="container">
      <div class="row d-flex justify-content-center">
        <!--        <div>-->
        <!--          <img src="@/assets/images/pleisure/pleisure_headerimage.jpg" />-->
        <!--        </div>-->
        <div class="col-lg-12 rowSpace"></div>
        <div class="text-center col-lg-12 mainTitle">가을맞이 치얼스데이</div>
        <div class="mainTitleLine">
          <hr />
        </div>
        <div class="col-lg-12 text-center mainIntro">P-Leisure 가을맞이 기념 이벤트 오픈!</div>
        <div class="rowSpace"></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">이전</button>
          <router-link to="/p/Realtimebooking2" class="resserve-button"> 예약신청 </router-link>
          <!--          <router-link to="/p/Reservpleisure/7" class="resserve-button"> 예약신청 </router-link>-->
        </div>
        <div class="rowSpace"><hr /></div>
        <!--
        <GallerySlideCarousels :slides="main_slides" :slide-count="3" :thumb-slide-width="45" />
        -->
        <div class="container">
          <img src="@/assets/images/pleisure/promotion/promotion_01.png" style="width: 100%" />
        </div>
      </div>
    </div>

    <div class="container subContainer">
      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 mainInfo">
          <div class="mb-3">P-Leisure 가을맞이 기념 이벤트 오픈!</div>
          <div class="mb-3">P레저가 가을과 어울리는 레저를 제안합니다.</div>
          <div class="mb-3">
            ʻ세계적인 건축가의 감성을 만끽할 수 있는 아트&힐링’<br />
            ʻ전문 교관의 정통 승마 강습부터 외승 체험까지 즐길 수 있는 노블승마’
          </div>
          <div class="mb-3">
            기간 내에 해당 프로그램을 이용하신 고객님께 와인 1bottle을 증정합니다.<br />
            선선한 바람과 함께 즐기는 P레저와 함께 로맨틱한 가을을 즐겨보세요.
          </div>
          <div class="mb-3">
            - 기간 : 2022.10.15 ~ 2022.11.30<br />
            - 적용 프로그램 : 아트&힐링 / 노블승마<br />
            - 제공 혜택 : 와인 1bottle 증정 (팀 당 적용)
          </div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">이전</button>
          <router-link to="/p/Realtimebooking2" class="resserve-button"> 예약신청 </router-link>
          <!--          <router-link to="/p/Reservpleisure/7" class="resserve-button"> 예약신청 </router-link>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import GallerySlideCarousels from '@/components/GallerySlideCarousels';
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'fallincheersday',
  data() {
    return {
      eventpromotion_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS',
        present: '이벤트&프로모션',
      },
      main_slides: [],
      addition_slides: [],
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: '가을맞이 치얼스데이'});
  },
  components: {Breadcrumb},
};
</script>

<style scoped lang="scss">
td {
  vertical-align: middle;
}
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
.mainTitle {
  font-weight: 800;
  font-size: 2rem;
  letter-spacing: -0.1rem;
}
.mainTitleLine {
  width: 10%;
  > hr {
  }
}
.mainIntro {
}
.buttonArea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .resserve-button {
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: #524a3d;
    color: #fff;
  }
  .prev-button {
    justify-content: center;
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: white;
    color: #000;
    border: 1px solid black;
  }
}
.subContainer {
  width: 100%;
}
.mainInfo {
  padding: 1rem;
  width: 100%;
  height: 100%;
  > div {
    line-height: 1.5rem;
    font-size: 1rem;
    word-break: keep-all;
  }
}
.serviceArea {
  padding: 1rem;
  > span {
    font-size: 0.8rem;
  }
}
.subTitle {
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.subDetail {
  font-size: 0.9rem;
  padding-left: 1rem;
}
.subTable {
  > thead {
    background-color: #eaeaea;

    > tr > td {
      text-align: center;
      font-weight: 600;
    }
  }
  > tbody {
    > tr > td {
      text-align: center;
      font-size: 0.9rem;
    }
  }
}

.rowSpace {
  width: 100%;
  height: 2rem;
  > hr {
  }
}

.headerimage {
  width: 100%;
  margin: 0;
  content: url('~@/assets/images/common/promotion_headerimage.jpg');
}

@media (max-width: 992px) {
  .headerimage {
    display: none;
  }

  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }
}
</style>
